export const queryKeys = {
  JOB_RESULT: 'JOB_RESULT'
};
